import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="relative  flex items-center justify-center">
      <div className="relative z-10 mt-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full py-20">
        {/* Image - shown first on mobile, left side on desktop */}
        <div className="w-full md:hidden mb-8 h-[170px] overflow-hidden rounded-lg shadow-lg">
          <img
            src="/assets/hero-image.jpg"
            alt="Healthcare professionals"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <h1 className="text-3xl sm:text-5xl text-accent mb-12 leading-tight tracking-tight text-center">
          Advisors at the Intersection of Health Policy and Technology Innovation
        </h1>

        <div className="flex flex-col md:flex-row md:items-stretch gap-8 md:gap-12">
          {/* Image - hidden on mobile, shown on desktop */}
          <div className="hidden md:flex w-full md:w-1/2 flex-shrink-0">
            <img
              src="/assets/hero-image.jpg"
              alt="Healthcare professionals"
              className="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>
            <div className="w-full md:w-1/2">
                <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
                    Onyx Rose Advisors is a premier, mission-driven consulting firm and certified woman-owned business operating at the intersection of health policy and technology innovation. We deliver strategic, data-informed solutions that help clients navigate the complexities of healthcare and digital transformation. 
                </p>

                <p className="mt-6 text-lg sm:text-xl text-gray-700 leading-relaxed">
                    Our team specializes in policy analysis, program strategy, coalition building, and technical advisory services, supporting initiatives across government health programs, managed care, health IT, and emerging technologies. We are proud to partner with clients who are driving meaningful change—helping them refine priorities, implement solutions, and achieve measurable impact.
                </p>
                <a
                  href="/our-team"
                  className="inline-block mt-8 bg-accent text-white font-semibold px-4 py-2 rounded-md hover:bg-accent-900 transition-colors duration-200"
                >
                 Learn more
                </a>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
